import '../css/autocomplete.scss';

import util from '../../../common/util';
import global from '../../../common/global';

export default function (inp, country, onselect, option = {}) {
    if (!inp) {
        return;
    }
    let elem =
        document && document.body.appendChild(document.createElement('ul'));
    elem.classList = 'autocomplete';
    let arg = {
        country: countryMap[country] || country,
        inp: inp,
        list: elem,
        count: 0,
        selected: -1,
        visible: false,
        onselect,
        ...option
    };
    inp.addEventListener('keyup', onKeyup.bind(inp, arg));
    inp.addEventListener('compositionstart', onCompositionstart.bind(inp, arg));
    inp.addEventListener('compositionend', onCompositionend.bind(inp, arg));
    inp.addEventListener('focus', onFocus.bind(inp, arg));
    inp.addEventListener('blur', onBlur.bind(inp, arg));
    // https://jira.chimeinc.com/browse/CHIME-16042
    document.body.addEventListener('click', () => {
        // https://jira.chimeinc.com/browse/CHIME-23416
        showSuggestionList(null, arg);
    });
    inp.addEventListener('click', e => {
        e.stopPropagation();
    });
    elem.addEventListener('click', onSelect.bind(elem, arg));

    return {
        getPlace() {
            // return option.selected !== -1 ? { address_components: true } : null;
            return { address_components: true };
        },
        getSuggestion() {
            let list = [],
                childNodes = elem.childNodes;
            for (let i = 0, len = childNodes.length; i < len; i++) {
                list.push(childNodes[i].innerText);
            }
            return list;
        },
        close() {
            showSuggestionList(null, arg);
        }
    };
}

function onKeyup(option, evt) {
    if (!option.lockedInput) {
        switch (evt.keyCode) {
            case 40: // key down
                selectNext(option);
                break;
            case 38: // key up
                selectPrev(option);
                break;
            default:
                getSuggestion(this.value, option);
        }
    }
}

function onCompositionstart(option) {
    option.lockedInput = true;
}

function onCompositionend(option) {
    option.lockedInput = false;
}

function selectNext(option) {
    let idx = option.selected,
        items = option.list.childNodes;
    if (idx === option.count - 1) {
        items[idx].className = 'item';
        option.selected = -1;
        option.inp.value = option.value;
    } else {
        if (idx !== -1) {
            items[idx].className = 'item';
        }
        idx = (idx + 1) % option.count;
        option.selected = idx;
        items[idx].className = 'item selected';
        option.inp.value = items[idx].innerText;
    }
}

function selectPrev(option) {
    let idx = option.selected,
        items = option.list.childNodes;
    if (idx === 0) {
        items[idx].className = 'item';
        option.selected = -1;
        option.inp.value = option.value;
    } else {
        if (idx !== -1) {
            items[idx].className = 'item';
        } else {
            idx = 0;
        }
        idx = (idx - 1 + option.count) % option.count;
        option.selected = idx;
        items[idx].className = 'item selected';
        option.inp.value = items[idx].innerText;
    }
}

function onFocus(option) {
    getSuggestion(this.value, option);
}

function onBlur(option, evt) {
    let posList = option.list.compareDocumentPosition(evt.target);
    if (posList !== 20 && posList !== 0 && option.inp !== evt.target) {
        showSuggestionList(null, option);
        if (option.selected !== -1) {
            util.call(option.onselect, option.inp.value);
        }
    }
}

function onSelect(option, evt) {
    let target = evt.target;
    if (target !== this) {
        if (target.tagName.toLowerCase() !== 'li') {
            target = target.parentNode;
        }
        option.selected = +target.getAttribute('data-idx');
        let text = target.innerText;
        option.inp.value = text;
        util.call(option.onselect, option.inp.value);
    }
    showSuggestionList(null, option);
}

function fetchSuggestion(value, option) {
    Suggestions[value] = true;
    util.simpleAxios
        .get('https://autocomplete.geocoder.ls.hereapi.com/6.2/suggest.json', {
            params: {
                query: value,
                country: option.country,
                beginHighlight: encodeURIComponent('<mark>'),
                endHighlight: encodeURIComponent('</mark>'),
                maxresults: option?.maxresults || 10,
                language: 'en',
                apikey: window.sitePrepareData().hereApiKey
            }
        })
        .then(res => {
            var suggestions = res.data && res.data.suggestions;
            let html = [];
            if (suggestions) {
                let addr = [];
                // filter address level 
                if (option.filterLevel) {
                    suggestions = suggestions.filter(
                        item => item?.address?.[option.filterLevel]
                    );
                }
                for (
                    let i = 0, k = 0, len = suggestions.length;
                    k < 5 && i < len;
                    i++
                ) {
                    let address = formatAddress(suggestions[i]);
                    if (address && addr.indexOf(address) === -1) {
                        addr.push(address);
                        html.push(
                            `<li class="item" data-idx="${i}">${address}</li>`
                        );
                        k++;
                    }
                }
            }
            suggestions = Suggestions[value] = {
                html: html.join(''),
                count: html.length
            };
            if (value === option.inp.value.trim()) {
                showSuggestionList(suggestions, option);
            }
        });
}

function getAddressItem(address, names, comma) {
    let addr = [],
        lastItem;
    for (let i = 0, len = names.length; i < len; i++) {
        let item = address[names[i]];
        if (item && lastItem !== item) {
            addr.push((lastItem = item));
        }
    }
    return addr.length ? addr.join(' ') + (comma === false ? '' : ', ') : '';
}

function formatAddress(item) {
    let address = item.address,
        detailAddr =
            getAddressItem(address, ['houseNumber', 'street']) +
            getAddressItem(address, ['city']);
    return detailAddr
        ? decodeURIComponent(
              detailAddr +
                  getAddressItem(address, ['state', 'postalCode'], false)
          )
        : null;
}

function getSuggestion(value, option) {
    value = value.trim();
    if (!value) {
        showSuggestionList('', option);
    } else {
        let suggestions = Suggestions[value];
        if (suggestions === undefined) {
            util.timeout({
                handler: fetchSuggestion,
                args: [value, option],
                delay: 100,
                unique: true
            });
        } else if (suggestions !== true) {
            showSuggestionList(suggestions, option);
        }
    }
}

function showSuggestionList(suggestions, option) {
    if (suggestions && suggestions.count) {
        if (!option.visible) {
            option.visible = true;
            let rect = option.inp.getBoundingClientRect(),
                stop = global.scroll('fetch'),
                css,
                zIdx = 100;

            let curEl = option.inp,
                curZIdx;
            while (curEl && curEl.tagName != 'BODY') {
                curZIdx = getComputedStyle(curEl).zIndex;
                curEl = curEl.parentNode;
                if (
                    (curZIdx = parseInt(curZIdx)) &&
                    !isNaN(curZIdx) &&
                    curZIdx > zIdx
                ) {
                    zIdx = curZIdx;
                }
            }
            if (window.innerHeight - rect.bottom < 50) {
                css = `; bottom: ${rect.top + stop}px;`;
            } else {
                css = `; top: ${rect.bottom + stop}px;`;
            }

            if (window.location.pathname == '/profile') {
                //  right profile page myHomes  The width of the suggested item is treated specially 
                const inputDom = document.querySelector('.home-input');
                const inputDomWidth =
                    inputDom?.clientWidth || rect.right - rect.left;
                option.list.style.cssText =
                    css +
                    `left: ${rect.left}px; width: ${inputDomWidth}px; z-index:${zIdx};`;
            } else {
                option.list.style.cssText =
                    css +
                    `left: ${rect.left}px; width: ${
                        rect.right - rect.left
                    }px; z-index:${zIdx};`;
            }
        }
        option.selected = -1;
        option.value = option.inp.value;
        option.count = suggestions.count;
        option.list.innerHTML = suggestions.html;
    } else {
        option.visible = false;
        option.list.style.cssText = 'left: -999px; height: -999px;';
    }
}

const Suggestions = {};

const countryMap = {
    us: 'usa',
    ca: 'can',
    canada: 'can'
};
